import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthService } from '../@services/auth.service';

@Component({
  selector: 'app-not-found-404',
  imports: [CommonModule],
  templateUrl: './not-found-404.component.html',
  styleUrl: './not-found-404.component.scss'
})
export class NotFound404Component {
  constructor(public authService: AuthService) {}

  on_logout() {
    this.authService.logout();
  }
}
